module.exports = __webpack_public_path__ + "static/media/iphone6-2up-grid-expanded.47e3a047.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/smartphone/iphone6/iphone6-2up-grid-expanded.pdf
// module id = 34
// module chunks = 0